import { Autocomplete, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, IconButton, InputAdornment, Radio, RadioGroup, Stack, TextField, Typography } from '@mui/material';
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';
import '../../../FrontOffice/IPPatients/PatientsDetails/ClinicalNotes/DoctorNotes.css'
import { DeletePopup } from '../../../../Components/Common Components/CommonComponents';
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg';
import { Colors } from '../../../../Styles/Colors';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import AddIcon from '@mui/icons-material/Add';
import { DateTime } from 'luxon';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { localGetItem } from '../../../../Utility/Services/CacheProviderService';

class DocAllergiesRight extends Component {
  constructor(props) {
    super(props)
    this.state = {
      AllergyType: "1",
      AllergyStatus: "active",
      AllergyName: "",
      NewAllergyName: "",
      AllergyComments: "",
      NewAllergyAdd: false,
      allergyNameList: [],
      SelectedId: null,
      isConfm: false,
      genericNameList: [], 
      debouncedValue: ''
    }
    this.debounceTimer = null;
  }
  componentDidMount() {
    if (this.props.EditAllergyData && Object.keys(this.props?.EditAllergyData).length !== 0) {
      this.setState({
        AllergyType: this.props.EditAllergyData?.allergy_type ? this.props.EditAllergyData?.allergy_type : "1",
        AllergyStatus: this.props.EditAllergyData?.is_active ? "active" : "inactive",
        AllergyName: this.props.EditAllergyData?.name ? this.props.EditAllergyData?.name : "",
        AllergyComments: this.props.EditAllergyData?.comments ? this.props.EditAllergyData?.comments : "",
        SelectedId: this.props.EditAllergyData?.id ? this.props.EditAllergyData?.id : null,
      }, () => {
        this.props.ClearPropsData()
      })
    } else {
      this.getAllergyNameList(true)
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.EditAllergyData !== this.props.EditAllergyData && Object.keys(this.props.EditAllergyData).length !== 0) {
      this.setState({
        AllergyType: this.props.EditAllergyData?.allergy_type ? this.props.EditAllergyData?.allergy_type : "1",
        AllergyStatus: this.props.EditAllergyData?.is_active ? "active" : "inactive",
        AllergyName: this.props.EditAllergyData?.name ? this.props.EditAllergyData?.name : "",
        AllergyComments: this.props.EditAllergyData?.comments ? this.props.EditAllergyData?.comments : "",
        SelectedId: this.props.EditAllergyData?.id ? this.props.EditAllergyData?.id : null,
      }, () => {
        let isAllergy = this.state.allergyNameList.some((list) => (list === this.state.AllergyName))
        if (!isAllergy) {
          let List = this.state.allergyNameList
          List.push(this.state.AllergyName)
          this.setState({
            allergyNameList: List,
          })
        }
        this.props.ClearPropsData()
      })
    }
    if (prevState.NewAllergyName !== this.state.NewAllergyName) {
      // Clear previous debounce timer
      clearTimeout(this.debounceTimer);

      // Set new debounce timer
      this.debounceTimer = setTimeout(() => {
        this.setState({ debouncedValue: this.state.NewAllergyName }, () => {
          if (this.state.debouncedValue) {
            this.getGenericList();
          }
        });
      }, 500);
    }
  }

  getGenericList = () => {
     try {
      RestAPIService.getAll(Serviceurls.GENERIC_MASTER_SUGGESTION + '?generic_name=' + encodeURIComponent(this.state.debouncedValue))
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              genericNameList: response.data.genric_names
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
 
  getAllergyNameList = (AddItemIfNot = false) => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_DOCTOR_NOTES_ALLERGY_FEQ)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              allergyNameList: response.data.data
            }, () => {
              if (AddItemIfNot && this.state.AllergyName) {
                let isAllergy = this.state.allergyNameList.some((list) => (list === this.state.AllergyName))
                if (!isAllergy) {
                  let List = this.state.allergyNameList
                  List.push(this.state.AllergyName)
                  this.setState({
                    allergyNameList: List,
                  })
                }
              }
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  ClearData() {
    if(this.state.SelectedId !== null){
      this.props.CallgetApi('allergies')
    }
    this.setState({
      AllergyType: "1",
      AllergyStatus: "active",
      AllergyName: "",
      NewAllergyName: "",
      AllergyComments: "",
      NewAllergyAdd: false,
      SelectedId: null,
      isDeleteClicked: false,
      isConfm: false,
    })
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message,
      isDeleteClicked: false,
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  DeleteAllergy() {
    try {
      var states = this.state
      RestAPIService.delete(Serviceurls.DOC_DOCTOR_NOTES_ALLERGY_FEQ + "?allergy=" + states.SelectedAllergy).
        then((response) => {
          if (response.data.status === "success") {
            this.ClearData()
            this.getAllergyNameList()
          } else {
            this.errorMessage(response.data.message)
          }
        }).catch(error => {
          this.errorMessage(error.message)
        })
    }
    catch (e) {
      this.errorMessage(e.message)
    }
  }

  PostAllergies() {
    try {
      var states = this.state
      if (this.state.AllergyType === '3' || CommonValidation.removeSpace(this.state.AllergyName) !== "") {
        let data = {
          appointment_id: this.props?.PatientData?.appointment_id,
          patient_id: this.props?.PatientData?.patient_id,
          allergies: {
            allergy_type: this.state.AllergyType,
            comments: this.state.AllergyComments,
            diagnosed_date: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
            id: this.state.SelectedId ? this.state.SelectedId : null,
            is_active: this.state.AllergyStatus === "active" ? true : false,
            name: this.state.AllergyName
          }
        }

        RestAPIService.create(data, Serviceurls.DOC_DOCTOR_NOTES_ALLERGIES).
          then((response) => {
            if (response.data.status === "success") {
              this.successMessage(response.data.message)
              this.ClearData()
              this.props.CallgetApi('allergies')
            } else {
              this.errorMessage(response.data.message)
            }
          }).catch(error => {
            if (error?.response?.data?.status === "fail") {
              this.errorMessage(error.response.data.message)
            } else {
              this.errorMessage(error.message)
            }
          })
      } else {
        this.errorMessage("Select Allergy Name")
      }
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  postTemplateData = () => {
    try {
      let data = {
        doctor_category: this.state.CategoryAddText
      }
      this.setState({ loading: true })
      RestAPIService.create(data, Serviceurls.DOC_DOCTOR_NOTES_PATIENT_CATEGORY_WISE)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.successMessage(response?.data?.message)
            this.ClearData()
            this.getPatientCategoryList()
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ loading: false })
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ loading: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ postLoad: false })
      this.errorMessage(error.message)
    }
  }

  popupClose() {
    this.setState({ isDeleteClicked: false })
  }

  renderAlertPop = () => {
    return(
      <Box emed_tid="doc_allergies_right_alert_popup_container">
        <Dialog
          emed_tid="doc_allergies_right_alert_popup_dialog"
          open={this.state.isConfm}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" emed_tid="doc_allergies_right_alert_popup_title">
            <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}} emed_tid="doc_allergies_right_alert_popup_title_box">
              <Typography fontSize={'1.2vw'} emed_tid="doc_allergies_right_alert_popup_title_text">Are You Sure?</Typography>
              <IconButton onClick={() => { this.setState({ isConfm: false }) }} emed_tid="doc_allergies_right_alert_popup_close_btn">
                <img src={ImagePaths.LabCloseButton.default} style={{ width: '1.2vw', height: '1.2vw'}} alt='name' emed_tid="doc_allergies_right_alert_popup_close_icon" />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent emed_tid="doc_allergies_right_alert_popup_content">
            <Box sx={{ backgroundColor: '#FFF4E6', display: 'flex', height: '8vw', alignItems: 'center' }} emed_tid="doc_allergies_right_alert_popup_message_box">
              <img src={ImagePaths.WarAlert.default} style={{ width: '2vw', height: '2vw', marginLeft: '.5vw', marginRight: '.5vw'}} alt='name' emed_tid="doc_allergies_right_alert_popup_icon" />
              <Typography fontSize={'1vw'} emed_tid="doc_allergies_right_alert_popup_message">
                This patient has documented allergies previously. Do you want to update the record to indicate no allergies now?
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions emed_tid="doc_allergies_right_alert_popup_actions">
            <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize' }} onClick={() => { this.setState({ isConfm: false }) }} emed_tid="doc_allergies_right_alert_popup_no_btn">No</Button>
            <Button size='small' variant='contained' sx={{ textTransform: 'capitalize' }} onClick={()=> {this.PostAllergies()}} emed_tid="doc_allergies_right_alert_popup_yes_btn">Yes</Button>
          </DialogActions>
        </Dialog>
      </Box>
    )
  }

  render() {
    let LoggedData = localGetItem("loggedInUserInfo") ? JSON.parse(localGetItem("loggedInUserInfo")) : null
    const { t } = this.props
    return (
      <Box emed_tid="doc_allergies_right_container">
        <Typography className='eMed_refdoc_title' emed_tid="doc_allergies_right_title">{this.props.SelectedCompCustomName ? this.props.SelectedCompCustomName : "Allergies"}</Typography>
        <Box height={"56.5vh"} overflow={'auto'} emed_tid="doc_allergies_right_content">
          <Box emed_tid="doc_allergies_right_type_box">
            <FormControl sx={{ marginLeft: "1vw" }} emed_tid="doc_allergies_right_type_formcontrol">
              <RadioGroup
                emed_tid="doc_allergies_right_type_radiogroup"
                value={this.state.AllergyType}
                sx={{ display: 'flex', flexDirection: 'row' }}
                onChange={(e) => { this.setState({ AllergyType: e.target.value, AllergyName: '' }) }}
              >
                <FormControlLabel value="1" control={<Radio size='small' emed_tid='doc_allergies_right_type_medication_radio'/>} label="Medication Allergy" emed_tid="doc_allergies_right_type_medication_label" />
                <FormControlLabel value="2" control={<Radio size='small' emed_tid='doc_allergies_right_type_non_medication_radio'/>} label="Non Medication Allergy" emed_tid="doc_allergies_right_type_non_medication_label" />
                <FormControlLabel value="3" control={<Radio size='small' emed_tid='doc_allergies_right_type_no_allergy_radio'/>} label="No Allergy" emed_tid="doc_allergies_right_type_no_allergy_label" />
              </RadioGroup>
            </FormControl>
          </Box>
          {this.state.AllergyType === '3' ? null : 
          <Box emed_tid="doc_allergies_right_name_box">
            <Typography className='eMed_refdoc_title' emed_tid="doc_allergies_right_name_label">{t("Allergy Name")}</Typography>
            <Box emed_tid="doc_allergies_right_name_chips_box">
              <Box className="eMed_DocNotes_FreqChips_Wrapp" emed_tid="doc_allergies_right_name_chips_wrapper">
                {
                  this.state.allergyNameList?.length > 0 ? this.state.allergyNameList.map((item, index) => (
                    <Chip
                      emed_tid={`doc_allergies_right_name_chip_${index}`}
                      size='small'
                      className={`eMed_chip ${this.state.AllergyName === item ? 'eMed_Chip_OnClick' : 'eMed_Chip_Border'}`}
                      key={index}
                      label={item}
                      variant={this.state.AllergyName === item ? 'contained' : "outlined"}
                      onClick={() => { this.setState({ AllergyName: item }) }}
                      onDelete={() => { this.setState({ isDeleteClicked: true, SelectedAllergy: item }) }}
                    />
                  )) : null
                }
                {this.state.NewAllergyAdd ?
                  (this.state.AllergyType === '1'  && !LoggedData?.show_allergy_suggetiom ) ?
                   <Autocomplete
                      emed_tid="doc_allergies_right_name_new_autocomplete"
                      freeSolo
                      size="small"
                      options={this.state.genericNameList  || []}
                      value={this.state.NewAllergyName}
                      onChange={(e, newValue) => {
                        if (typeof newValue === 'string') {
                          this.setState({ NewAllergyName: newValue });
                        }
                      }}
                      inputValue={this.state.NewAllergyName}
                      onInputChange={(e, newInputValue) => {
                        this.setState({ NewAllergyName: e.target.value })
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          emed_tid="doc_allergies_right_name_new_textfield"
                          placeholder="Add Allergy"
                          inputProps={{
                            ...params.inputProps,
                            maxLength: 30,
                            style: { height: "0.9vw"},
                            emed_tid: "doc_allergies_right_name_new_input"
                          }}
                          sx={{ width: "15vw", marginLeft: "0.5vw", marginTop: "0.3vw"}}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" && this.state.NewAllergyName !== "") {
                              const List = [...this.state.allergyNameList];
                              if (!List.includes(this.state.NewAllergyName)) {
                                List.push(this.state.NewAllergyName);
                              }
                              else{
                                this.errorMessage("This allergy already exist")
                              }
                              this.setState({
                                allergyNameList: List,
                                AllergyName: this.state.NewAllergyName,
                                NewAllergyName: "",
                                NewAllergyAdd: false,
                              });
                              e.preventDefault(); // Prevents dropdown selection
                            }
                          }}
                          InputProps={{
                            ...params.InputProps,
                             sx: {
                                paddingRight: '8px',  // override root input padding
                              },
                            endAdornment: (
                              <InputAdornment position="end" emed_tid="doc_allergies_right_name_new_adornment">
                                <IconButton
                                  disabled={this.state.NewAllergyName === ""}
                                  onClick={() => {
                                    const List = [...this.state.allergyNameList];
                                    if (!List.includes(this.state.NewAllergyName)) {
                                      List.push(this.state.NewAllergyName);
                                    }
                                    else{
                                      this.errorMessage("This allergy already exist")
                                    }
                                    this.setState({
                                      allergyNameList: List,
                                      AllergyName: this.state.NewAllergyName,
                                      NewAllergyName: "",
                                      NewAllergyAdd: false,
                                    });
                                  }}
                                  emed_tid="doc_allergies_right_name_new_add_btn"
                                >
                                  <AddIcon color={this.state.NewAllergyName === "" ? "grey" : "primary"} emed_tid="doc_allergies_right_name_new_add_icon" />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                    : 
                    <TextField
                    emed_tid="doc_allergies_right_name_new_textfield_simple"
                    size='small'
                    value={this.state.NewAllergyName}
                    onChange={(e) => {
                      this.setState({ NewAllergyName: e.target.value })
                    }}
                    inputProps={{ maxLength: 30, style: { height: "0.8vw" }, emed_tid: "doc_allergies_right_name_new_input_simple" }}
                    sx={{ width: "10vw", marginLeft: "0.5vw", marginTop: '0.3vw' }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && this.state.NewAllergyName !== "") {
                        let List = this.state.allergyNameList
                        List.push(this.state.NewAllergyName)
                        this.setState({
                          allergyNameList: List,
                          AllergyName: this.state.NewAllergyName,
                          NewAllergyName: "",
                          NewAllergyAdd: false
                        })
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end" emed_tid="doc_allergies_right_name_new_adornment_simple">
                          <IconButton
                            disabled={this.state.NewAllergyName === ""}
                            onClick={() => {
                              let List = this.state.allergyNameList
                              List.push(this.state.NewAllergyName)
                              this.setState({
                                allergyNameList: List,
                                AllergyName: this.state.NewAllergyName,
                                NewAllergyName: "",
                                NewAllergyAdd: false
                              })
                            }}
                            emed_tid="doc_allergies_right_name_new_add_btn_simple">
                            <AddIcon color={this.state.NewAllergyName === "" ? 'grey' : 'primary'} emed_tid="doc_allergies_right_name_new_add_icon_simple" />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }} /> :
                  <IconButton
                    onClick={() => {
                      this.setState({
                        NewAllergyAdd: true
                      })
                    }}
                    emed_tid="doc_allergies_right_name_add_btn">
                    <AddIcon color={'primary'} emed_tid="doc_allergies_right_name_add_icon" />
                  </IconButton>
                }
              </Box>
            </Box>
          </Box>}
          {this.state.AllergyType === '3' ? null :  
          <Box emed_tid="doc_allergies_right_status_box">
            <Typography className='eMed_refdoc_title' emed_tid="doc_allergies_right_status_label">{t("Allergy Status")}</Typography>
            <FormControl sx={{ marginLeft: "1vw" }} emed_tid="doc_allergies_right_status_formcontrol">
              <RadioGroup
                emed_tid="doc_allergies_right_status_radiogroup"
                value={this.state.AllergyStatus}
                sx={{ display: 'flex', flexDirection: 'row' }}
                onChange={(e) => { this.setState({ AllergyStatus: e.target.value }) }}
              >
                <FormControlLabel value="active" control={<Radio size='small' emed_tid='doc_allergies_right_status_active_radio'/>} label="Active" emed_tid="doc_allergies_right_status_active_label" />
                <FormControlLabel value="inactive" control={<Radio size='small' emed_tid='doc_allergies_right_status_inactive_radio'/>} label="InActive" emed_tid="doc_allergies_right_status_inactive_label" />
              </RadioGroup>
            </FormControl>
          </Box> }
          <Box emed_tid="doc_allergies_right_comments_box">
            <Typography className='eMed_refdoc_title' emed_tid="doc_allergies_right_comments_label">{t("Comments")}</Typography>
            <TextField
              emed_tid="doc_allergies_right_comments_textfield"
              size='small'
              className='eMed_DocNotes_TextFields'
              multiline={true}
              rows={3}
              label={t("Comments ( Max 250 characters)")}
              inputProps={{ maxLength: 250, emed_tid: "doc_allergies_right_comments_input" }}
              value={this.state.AllergyComments}
              onChange={(e) => {
                if (CommonValidation.ALPHA_NUM_SPLCHAR(e.target.value) || e.target.value === "") {
                  this.setState({ AllergyComments: e.target.value })
                }
              }}
            />
          </Box>
        </Box>
        <Stack spacing={2} direction="row" sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center" height={"6vh"} emed_tid="doc_allergies_right_actions">
          <Button variant='outlined' size="small" _id="eMed_Config_btn" onClick={() => { this.ClearData() }} emed_tid="doc_allergies_right_clear_btn">{t("Clear")}</Button>
          <Button variant='contained' size="small" id="eMed_Config_btn" onClick={() => { (this.state.AllergyType === '3' && this.props.allergyData.length > 0) ? this.setState({ isConfm: true }) : this.PostAllergies() }} emed_tid="doc_allergies_right_add_btn">{t("Add")}</Button>
        </Stack>
        {this.state.isErrorMsg ?
          <ToastMsg
            emed_tid="doc_allergies_right_error_toast"
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            emed_tid="doc_allergies_right_success_toast"
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.isDeleteClicked ? <DeletePopup
          emed_tid="doc_allergies_right_delete_popup"
          DeletTitle={`${t("deleteMsg")}  ${t("Allergy")} ${this.state.SelectedAllergy ? this.state.SelectedAllergy : "-"} From Frequent List ?`}
          deleteAlertPopupClose={this.popupClose.bind(this)}
          removeData={this.DeleteAllergy.bind(this)}
        /> : null}
        {this.state.isConfm ? this.renderAlertPop() : null}
      </Box>
    )
  }
}
export default withTranslation()(DocAllergiesRight)
